import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FieldRow } from '../ui';

// Field content only — the parent wraps this in EntityDrawer (create) or
// reuses it directly (Company Detail's "Edit company" uses the same fields).
const GACompanyForm = ({ form, setForm, errors = {} }) => {
  const { t } = useTranslation();
  return (
    <>
      <FieldRow label={t('ga.companies.name')} error={errors.companyName} required>
        <TextField
          fullWidth
          value={form.companyName}
          onChange={(e) => setForm({ ...form, companyName: e.target.value })}
          error={Boolean(errors.companyName)}
        />
      </FieldRow>
      <FieldRow label={t('ga.companies.email')} error={errors.companyEmail} required>
        <TextField
          fullWidth
          value={form.companyEmail}
          onChange={(e) => setForm({ ...form, companyEmail: e.target.value })}
          error={Boolean(errors.companyEmail)}
        />
      </FieldRow>
      <FieldRow label={t('ga.companies.phone')}>
        <TextField fullWidth value={form.companyPhone} onChange={(e) => setForm({ ...form, companyPhone: e.target.value })} />
      </FieldRow>
      <FieldRow label={t('ga.companies.address')}>
        <TextField fullWidth value={form.companyAddress} onChange={(e) => setForm({ ...form, companyAddress: e.target.value })} />
      </FieldRow>
    </>
  );
};

export default GACompanyForm;
